import Client from './Client';

export default class LoginClient {
  constructor() {
    this.client = Client;
  }

  /**
   * 登录
   */
  async login(data) {
    const res = await this.client.post('/api/user/loginBackend', data);
    return res;
  }

  /**
   * 获取用户信息
   */
  async getUserToken(data) {
    const res = await this.client.post('/api/user/getUserToken', data);
    return res;
  }

  /**
   * 登出
   */
  async logout() {
    const res = await this.client.post('/api/user/logout');
    return res;
  }
}